import { Box, Button, Grid, IconButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../Redux/store'
import { CartVariantImage, Item } from '../../../types/Cartlist'
import { VariantImage } from '../../../types/Products'
import { Add, ArrowForwardIosOutlined, ArrowForwardOutlined, CloseOutlined, DeleteOutlineOutlined, Remove } from '@mui/icons-material'
import { ApiDeleteCartItem, ApiGetCartList, ApiUpdateCartItem } from '../../../Core/Apicall'
import { setActiveCartStep, setCartList } from '../../../Redux/Reducers/globalSlice'
import { toast } from 'react-toastify'

function CartReview() {
    const { cartlist, activeCartStep } = useSelector((state: RootState) => state.global)
    const dispatch = useDispatch()
    const [quantity, setQuantity] = useState(
        cartlist?.items?.map((item: Item) => ({
            quantity: item?.quantity,
            finalPrice: item?.finalPrice,
            total: item?.total,
        })) || []
    );

    useEffect(() => {
        setQuantity(cartlist?.items?.map((item: Item) => ({
            quantity: item?.quantity,
            finalPrice: item?.finalPrice,
            total: item?.total,
        })) || [])
    }, [cartlist])


    const GetCartlist = async () => {
        try {
            const res = await ApiGetCartList()
            if (res?.status) {
                dispatch(setCartList(res?.data))
            }
        } catch (error: any) {
            console.log("Error", error)
            toast.error(error?.message || "Something went wrong");
        }
    }

    const updateCartItem = async (cartItemId: number, type: "Add" | "Remove", index: number,) => {
        try {
            const params = `?cartItemId=${cartItemId}`
            const data = {
                quantity: type === "Add" ? quantity?.[index]?.quantity + 1 : quantity?.[index]?.quantity - 1
            }
            const res = await ApiUpdateCartItem(params, data)
            if (res?.status) {
                GetCartlist()
            }
        } catch (error: any) {
            console.log("Error", error)
            toast.error(error?.message || "Something went wrong");
        }
    }

    const removeCartItem = async (cartItemId: number) => {
        try {
            const params = `?cartItemId=${cartItemId}`
            const res = await ApiDeleteCartItem(params)
            if (res?.status) {
                GetCartlist()
            }
        } catch (error: any) {
            console.log("Error", error)
            toast.error(error?.message || "Something went wrong");
        }
    }


    const getProceedNextButton = () => {
        return (
            <Box className='d-flex align-items-center justify-content-end'>
                <Button onClick={()=>{dispatch(setActiveCartStep(activeCartStep + 1))}} className='btn-main px-3'>Procced to Address&nbsp;<ArrowForwardOutlined /></Button>
            </Box>
        )
    }
    return (
        <Box>
            <Box>
                <Typography variant='body2' className='text-main fw-bold' gutterBottom>step 1 of 4</Typography>
                <Typography variant='h5' className='fw-bold'>Review Your Cart</Typography>
                <Typography variant='body2' className='text-grey' sx={{ letterSpacing: '1px' }}>Review your items and proceed to address</Typography>
            </Box>
            <Grid className='mt-3' container spacing={1} sx={{ alignItems: 'start' }}>
                <Grid size={{ xs: 12, md: 'grow' }} className='border bg-white border-10 p-3'>
                    <Typography variant='h6' className='fw-bold' gutterBottom>Your Cart ({cartlist?.items?.length} Items)</Typography>
                    <Box className='mt-2'>
                        {cartlist?.items?.map((item: Item, index: number) => (
                            <>
                                <Box key={index} className='d-flex flex-column flex-md-row align-items-center justify-content-between mb-2'>
                                    <Box className='d-flex align-items-center' sx={{ gap: '10px' }}>
                                        <Box component={'img'} height={'75px'} width={'75px'} className='border-10 border' src={item?.variant?.images?.find((image: CartVariantImage) => image?.is_thumbnail)?.imageUrl || item?.variant?.images?.[0]?.imageUrl} alt={`Item ${index}`} />
                                        <Box>
                                            <Typography variant='body2' className='fw-bold' gutterBottom>{item?.variant?.name}</Typography>
                                            <Box className='d-flex align-items-center gap-3'>
                                                <Typography variant='caption' gutterBottom>Size: {item?.variant?.size?.name}</Typography>
                                                <Typography variant='caption' gutterBottom>Color: {item?.variant?.color?.name}</Typography>
                                            </Box>
                                            <Box className='d-flex align-items-end gap-1'>
                                                <Typography variant='body2' className='fw-bold' gutterBottom>
                                                    {Number(item?.finalPrice).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "INR",
                                                    })}
                                                </Typography>
                                                <Typography variant='body2' className='fw-bold over-line' gutterBottom>
                                                    {Number(item?.price).toLocaleString("en-US", {
                                                        style: "currency",
                                                        currency: "INR",
                                                    })}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box className='d-flex align-items-center justify-content-between' sx={{ width: { xs: "100%", md: 'auto' } }}>
                                        <Typography variant='h6' className='fw-bold d-inline-block d-md-none'>
                                            {Number(quantity?.[index]?.total).toLocaleString("en-US", {
                                                style: "currency",
                                                currency: "INR",
                                            })}
                                        </Typography>
                                        <Box className='d-flex align-items-center gap-3'>
                                            <Box sx={{ width: 'fit-content' }} className='d-flex align-items-center border border-10 border-main overflow-hidden'>
                                                <IconButton
                                                    onClick={() => updateCartItem(item?.cartItemId, "Remove", index)}
                                                    disabled={quantity?.[index]?.quantity === 1}
                                                    sx={{ borderRadius: 0 }}
                                                >
                                                    <Remove />
                                                </IconButton>

                                                <Typography className=' text-center fw-bold mx-2'
                                                >
                                                    {quantity?.[index]?.quantity}
                                                </Typography>
                                                <IconButton
                                                    disabled={quantity?.[index]?.quantity === (Number(item?.variant?.availableStock) - 1)}
                                                    onClick={() => updateCartItem(item?.cartItemId, "Add", index)}
                                                    sx={{ borderRadius: 0 }}
                                                >
                                                    <Add />
                                                </IconButton>
                                            </Box>
                                            <Typography variant='body1' className='fw-bold d-md-inline-block d-none'>
                                                {Number(quantity?.[index]?.total).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "INR",
                                                })}
                                            </Typography>
                                            <IconButton onClick={() => { removeCartItem(item?.cartItemId) }}>
                                                <DeleteOutlineOutlined className='text-danger' />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </Box>
                                <hr />
                            </>
                        ))}
                    </Box>
                    <Box className='d-none d-md-block'>
                        {getProceedNextButton()}
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 3, xl:3 }} className='border bg-white border-10 p-3'>
                    <Typography variant='body1' className='fw-bold' gutterBottom>Order Summary</Typography>
                    <Box className='d-flex align-items-center justify-content-between gap-5 mb-2'>
                        <Typography className='text-grey' variant='body2'>Subtotal ({cartlist?.items?.length} Items)</Typography>
                        <Typography variant='body2'>
                            {Number(cartlist?.subtotal).toLocaleString("en-US", {
                                style: "currency",
                                currency: "INR",
                            })}
                        </Typography>
                    </Box>
                    <Box className='d-flex align-items-center justify-content-between gap-5 mb-2'>
                        <Typography className='text-grey' variant='body2'>Tax({cartlist?.taxPercentage}%)</Typography>
                        <Typography variant='body2'>
                            {Number(cartlist?.taxAmount).toLocaleString("en-US", {
                                style: "currency",
                                currency: "INR",
                            })}
                        </Typography>
                    </Box>
                    <Box className='d-flex align-items-center justify-content-between gap-5 mb-2'>
                        <Typography className='text-grey' variant='body2'>Shipping Amount</Typography>
                        <Typography variant='body2'>
                            {Number(cartlist?.shippingAmount).toLocaleString("en-US", {
                                style: "currency",
                                currency: "INR",
                            })}
                        </Typography>
                    </Box>
                    <Box className='d-flex align-items-center justify-content-between gap-5'>
                        <Typography className='text-grey' variant='body2'>Total Discount</Typography>
                        <Typography className='text-green' variant='body2'>
                            {Number(cartlist?.totalDiscount).toLocaleString("en-US", {
                                style: "currency",
                                currency: "INR",
                            })}
                        </Typography>
                    </Box>
                    <hr />
                    <Box className='d-flex align-items-center justify-content-between gap-5 mt-2'>
                        <Typography className='text-grey' variant='body1'>Total Amount</Typography>
                        <Typography className='text-dark-main fw-bold' variant='h6'>
                            {Number(cartlist?.grandTotal).toLocaleString("en-US", {
                                style: "currency",
                                currency: "INR",
                            })}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
             <Box className='d-block d-md-none mt-3'>
                        {getProceedNextButton()}
            </Box>
        </Box>
    )
}

export default CartReview
